import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  FormHelperText,
  Grid,CircularProgress
} from "@mui/material";
import { IconButton } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../AuthProvider";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {useParams, useLocation } from "react-router-dom";

export const BusFeeRegistrationForm = () => {
  const navigate = useNavigate();
   const { studentId } = useParams();

  const [errors, setErrors] = useState({});
  const [searchError, setSearchError] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const { userId, oId, role ,board,pId} = useAuth();
  const [busLoading, setBusLoading] = useState(false);
  const [routeNumberLoading, setRouteNumberLoading] = useState(false);
  const [locationLoading, setLocationLoading] = useState(false);
  const [busNumbers, setBusNumbers] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [routeLoading, setRouteLoading] = useState(false);
  const [routeNumber, setrouteNumber] = useState([]);
  const [loading, setLoading] = useState(false); // State to track loading

   const [users, setUsers] = useState([]);
   const [stops, setStops] = useState([]);
   const [selectedUsers, setSelectedUsers] = useState('');
   const isPrincipal = role?.startsWith("PRINCIPAL") || false;
   const UserId = userId || selectedUsers;

   const [routeNumbers, setRouteNumbers] = useState([]);

   const [isDisabled, setIsDisabled] = useState(false);


  const [formData, setFormData] = useState({
    admissionNumber: "",
    studentFirstName: "",
    studentLastName: "",
    romanNumberClass:"",
    course:"",
    sections:"",
    fatherName: "",
    // primaryContact: "",
    fatherPhoneNumber: "",
    address: "",
    gender: "",
    distance: "",
    busTotalFee: "",
    busNumber: "",
    routeNumber: "",
    studentPickupLocation: "",
    studentDropLocation: "",

    email: "",
  });
  

  const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" },
  ];


  const [adminusers, setadminUsers] = useState([]);
  const [selectedadminUsers, setSelectedadminUsers] = useState("");

  console.log("Selected admin:",selectedadminUsers);

  useEffect(() => {
    const fetchUsers = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/ADMISSION_FEE/${oId}/${pId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch users');
            }
            const data = await response.json();
            setadminUsers(data);
            if (data.length > 0) {
              setSelectedadminUsers(data[0].userId); // ✅ Set first record's userId as default
          }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

  // if (isPrincipal) {
    fetchUsers();
  // }
}, []); // ✅ Only runs on mount 


    const fetchUsers = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/TRANSPORT/${oId}/${pId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch users');
            }
            const data = await response.json();
            setUsers(data);
            if (data.length > 0) {
              setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
          }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
  useEffect(() => {
    if (isPrincipal) {
        fetchUsers();
    }
}, []);

//fetching BUS STOPS
// useEffect(() => {
//   const fetchStops = async () => {
//       try {
//           const response = await fetch(`${baseUrl}/api/SchedulingRoute/stops/bus/${formData.busNumber}/${oId}`);
//           if (!response.ok) {
//               throw new Error('Failed to fetch stos');
//           }
//           const data = await response.json();
//           setStops(data);
         
//       } catch (error) {
//           console.error('Error fetching stops:', error);
//       }
//   };
//   fetchStops();
// }, [formData.busNumber]);

useEffect(() => {
  const fetchStops = async () => {
    if (!formData.busNumber) return;

    try {
      const res = await fetch(
        `${baseUrl}/api/SchedulingRoute/stops/bus/${formData.busNumber}/${oId}/${pId}`
      );
      const data = await res.json();        // ⇢ data.stops is an array of fragments

      /* ---- Rebuild a clean array of stop names ---- */
      const cleanStops = data.stops
        .map((item) => item.stop)           // '[\"habs"'  → … → '"sa"]'
        .map((frag) =>
          frag
            .replace(/[\[\]"]/g, "")        // remove [, ], "
            .trim()
        )
        .filter(Boolean);                   // remove empty strings

      setStops(cleanStops);                 // e.g. ["habs","tam","sa"]
    } catch (err) {
      console.error("Error fetching stops:", err);
      setStops([]);
    }
  };

  fetchStops();
}, [formData.busNumber, oId]);





   useEffect(() => {
  const fetchData = async () => {
    if (!UserId) return;
    setBusLoading(true);
    setRouteLoading(true);

    try {
      const response = await fetch(
        `${baseUrl}/api/SchedulingRoute/all-bus-routes/${oId}/${UserId}`
      );
      if (!response.ok) {
        console.log("Failed to fetch data");
        return;
      }

      const data = await response.json();
      console.log("Fetched Data:", data);

      // Extract bus details
      const extractedBuses = data.map((item) => ({
        id: String(item.id),
        busNumber: item.busNumber || "Unknown Bus",
        routeNumber: item.routeNumber || "Unknown Route",
        busNumberPlate: item.busNumberPlate || "Unknown Plate",
        busPickupLocation: item.busPickupLocation || "Unknown Pickup",
        busDropLocation: item.busDropLocation || "Unknown Drop",
      }));

      console.log("Extracted Buses:", extractedBuses);

      setBusNumbers(extractedBuses); // ✅ Store full bus info

      // If you also want to keep routes separately:
      setRouteNumbers(extractedBuses.map((bus) => bus.routeNumber));

    } catch (error) {
      console.log("Failed to fetch data", error);
    } finally {
      setBusLoading(false);
      setRouteLoading(false);
    }
  };

  fetchData();
}, [baseUrl, UserId, oId]);



  const handleInputChange = (event) => {
    const { name, value } = event.target;
    console.log(`Field Updated: ${name}, New Value: ${value}`);
  
    setFormData((prevData) => {
      let updatedFormData = { ...prevData, [name]: value };
  
      // Auto-select the route when a busNumber is chosen
      if (name === "busNumber") {
        const matchedBus = busNumbers.find((bus) => bus.busNumber === value);
        updatedFormData.routeNumber = matchedBus ? matchedBus.routeNumber : "";
      }
  
      return updatedFormData;
    });
  
    // Validate and update errors
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value.trim() ? "" : `${name.replace(/([A-Z])/g, " $1")} is required`,
    }));
  };

  const fetchStudentDetails = async () => {
    if (!studentId) return;
    if (!oId) {
      setSearchError("Organization ID is missing.");
      return;
    }
  
    try {
      setSearchError("");
      setIsSearching(true);
  
      const response = await fetch(
        // `${baseUrl}/api/admission/getAllStudentsDetailsGeneratedAdmId/${formData.admissionNumber}/${oId}/${pId}`
         `${baseUrl}/api/admission/getAllSpecificStudentsDetails/${studentId}/${oId}`
      );
  
      const data = await response.json();
  
      if (response.ok && data) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          studentFirstName: data.firstName || "",
          studentLastName: data.lastName || "",
          fatherName: `${data.fathersFirstName} ${data.fathersLastName}` || "",
          fatherPhoneNumber: data.primaryContact || "",
          address: data.address || "",
          gender: data.gender || "",
          email: data.fathersMailId || "",
          romanNumberClass : data.romanNumberClass || "",
          course:data.course || "",
          sections:data.sections || "",
          studentId:data.studentId || "",
        }));
      } else {
        setSearchError("No record found for this Admission No.");
      }
    } catch (error) {
      setSearchError("Admission Details are Not Found.");
    } finally {
      setIsSearching(false);
    }
  };
   useEffect(() => {
        fetchStudentDetails();
}, [studentId,oId]);
  

 

  const validateForm = () => {
    const newErrors = {};
    if (!formData.studentFirstName)
      newErrors.studentFirstName = "First Name is required";
    if (!formData.studentLastName)
      newErrors.studentLastName = "Last Name is required";
    if (!formData.fatherName)
      newErrors.fatherName = "Father's Name is required";
    if (!formData.romanNumberClass)
      newErrors.romanNumberClass = "Class is required";
    if (!formData.sections)
      newErrors.sections = "Section is required";

    if (!/^\d{12}$/.test(formData.fatherPhoneNumber))
      newErrors.fatherPhoneNumber = "Invalid Phone Number";
    // if (!formData.address) newErrors.address = "Address is required";
    // if (!formData.gender) newErrors.gender = "Gender is required";
    // if (!formData.distance) newErrors.distance = "Distance is required";

    if (!formData.busTotalFee)
      newErrors.busTotalFee = "BusTotalFee is required";
    if (!formData.busNumber) newErrors.busNumber = "Bus Number is required";
    if (!formData.routeNumber) newErrors.routeNumber = "Route is required";
    if (!formData.studentPickupLocation)
      newErrors.studentPickupLocation = "Pickup  Location is required";
    if (!formData.studentDropLocation)
      newErrors.studentDropLocation = " Drop Location is required";

    // if (!formData.email) newErrors.email = "Email is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); // Start loading

      const formDataToSend = new FormData();
      formDataToSend.append("studentFirstName", formData.studentFirstName);
      formDataToSend.append("studentLastName", formData.studentLastName);
      formDataToSend.append("romanNumberClass", formData.romanNumberClass);
      formDataToSend.append("sections", formData.sections);
      formDataToSend.append("fatherName", formData.fatherName);
      formDataToSend.append("fatherPhoneNumber", formData.fatherPhoneNumber);
      formDataToSend.append("address", formData.address);
      formDataToSend.append("gender", formData.gender);
      formDataToSend.append("distance", formData.distance);
      formDataToSend.append("busTotalFee", formData.busTotalFee);
      formDataToSend.append("busNumber", formData.busNumber);
      formDataToSend.append("routeNumber", formData.routeNumber);
      formDataToSend.append("studentPickupLocation", formData.studentPickupLocation);
      formDataToSend.append("studentDropLocation", formData.studentDropLocation);
      formDataToSend.append("email", formData.email);
      formDataToSend.append("admStaffUserId", selectedadminUsers);

      try {
        const response = await fetch(
          `${baseUrl}/api/StudentBusList/save/${formData.studentId}/${UserId}`,
          {
            method: "POST",
            body: formDataToSend,
          }
        );
        
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(
            `Error: ${errorText}`
          );
        }

        toast.success("Student Registered successfully!", { autoClose: 1000 });
        // Delay navigation to let toast display
          setTimeout(() => {
            navigate('/TotalBusAttendanceList');
        }, 1000);

        
      } catch (error) {
        console.error("Error submitting form:", error);

        // Corrected error handling
        toast.error(error.message || "Failed to submit Student Registration. Please try again.", {
            autoClose: 2000,
        });
      }finally {
        setLoading(false); // Stop loading
      }
    }
  };

  return (
    <Box
      style={{
        margin: "60px 20px",
        padding: "10px",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        Height: "100vh",
        overflow: "hidden",
      }}
    >
      <Box display="flex" alignItems="center" sx={{ marginBottom: 2 }}>
        <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
          <KeyboardBackspaceIcon fontSize="medium" />
        </IconButton>
        <Typography variant="h4" component="h3" sx={{ fontWeight: "bold" }}>
          Student Bus Registration Form
        </Typography>
      </Box>

      {/* Search Input and Button */}
      {/* <Box sx={{ marginBottom: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={9}>
            <TextField
              fullWidth
              label="Enter Admission Number"
              name="admissionNumber"
              value={formData.admissionNumber}
              onChange={handleInputChange}
              // onBlur={fetchStudentDetails}
              error={!!searchError}
              helperText={searchError}
              sx={{ width: "30%" }}
            />
          <Button
  // sx={{
  //   marginLeft: "20px",
  //   marginTop: "10px",
  //   height:'30px',
  //   backgroundColor: "#007bff !important", // Custom blue color
  //   "&:hover": {
  //     backgroundColor: "#0056b3 !important", // Darker shade on hover
  //   },
  // }}
  variant="contained"
  fullWidth
   style={{
          height: '53px',
          width:'8rem',
          // marginTop: '25px',
          marginLeft:'10px',
          backgroundColor: '#3C3972',
          color: '#fff',
          fontWeight: 'bold',
        }}
  onClick={fetchStudentDetails} // Fetch on button click
  disabled={isSearching} // Disable while searching
>
  {isSearching ? "Searching..." : "Search"}
</Button>

          </Grid>
        
        </Grid>
      </Box> */}

      {/* Form onSubmit={handleSubmit} */}
      <form>
        <Box display="grid" gridTemplateColumns="repeat(3, 1fr)" gap="20px">
          {/* <TextField
            fullWidth
            label="Student First Name"
            name="studentFirstName"
            value={formData.studentFirstName}
            onChange={handleInputChange}
            error={!!errors.studentFirstName}
            helperText={errors.studentFirstName}
          /> */}

<TextField
  fullWidth
  label="Student First Name"
  name="studentFirstName"
  value={formData.studentFirstName}
  onChange={handleInputChange}
  error={!!errors.studentFirstName}
  helperText={errors.studentFirstName}

  InputProps={{
                readOnly: true,
                sx: {
                  backgroundColor: "#e0e0e0",
                  color: "#666",
                  borderRadius: "5px",
                  fontWeight:'bold',
                  pointerEvents: "none", 
                  "& .MuiInputBase-input": { color: "#666", cursor: "default" },
                },
              }}
/>


          
          

<TextField
  fullWidth
  label="Student Last Name"
  name="studentLastName"
  value={formData.studentLastName || "N/A"}
  onChange={handleInputChange}
  error={!!errors.studentLastName}
  helperText={errors.studentLastName}

  InputProps={{
                readOnly: true,
                sx: {
                  backgroundColor: "#e0e0e0",
                  color: "#666",
                  fontWeight:'bold',
                  borderRadius: "5px",
                  pointerEvents: "none", 
                  "& .MuiInputBase-input": { color: "#666", cursor: "default" },
                },
              }}
/>

<TextField
  fullWidth
  label={board === "INTERMEDIATE" ? "Year" : "Class"}
  name="romanNumberClass"
  value={`${formData.romanNumberClass}`}
  onChange={handleInputChange}
  error={!!errors.romanNumberClass}
  helperText={errors.romanNumberClass}
  InputProps={{
                readOnly: true,
                sx: {
                  backgroundColor: "#e0e0e0",
                  color: "#666",
                  fontWeight:'bold',
                  borderRadius: "5px",
                  pointerEvents: "none", 
                  "& .MuiInputBase-input": { color: "#666", cursor: "default" },
                },
              }}
/>

{board === "INTERMEDIATE" && (
  <TextField
    fullWidth
    label="Course"
    name="course"
    value={`${formData.course}`}
    InputProps={{
                readOnly: true,
                sx: {
                  backgroundColor: "#e0e0e0",
                  color: "#666",
                  fontWeight:'bold',
                  borderRadius: "5px",
                  pointerEvents: "none", 
                  "& .MuiInputBase-input": { color: "#666", cursor: "default" },
                },
              }}
  />
)}

<TextField
  fullWidth
  label="Section"
  name="sections"
  value={formData.sections}
  onChange={handleInputChange}
  error={!!errors.sections}
  helperText={errors.sections}
  InputProps={{
                readOnly: true,
                sx: {
                  backgroundColor: "#e0e0e0",
                  color: "#666",
                  fontWeight:'bold',
                  borderRadius: "5px",
                  pointerEvents: "none", 
                  "& .MuiInputBase-input": { color: "#666", cursor: "default" },
                },
              }}
/>

<TextField
  fullWidth
  label="Father's Name"
  name="fatherName"
  value={formData.fatherName}
  onChange={handleInputChange}
  error={!!errors.fatherName}
  helperText={errors.fatherName}

  InputProps={{
                readOnly: true,
                sx: {
                  backgroundColor: "#e0e0e0",
                  color: "#666",
                  fontWeight:'bold',
                  borderRadius: "5px",
                  pointerEvents: "none", 
                  "& .MuiInputBase-input": { color: "#666", cursor: "default" },
                },
              }}
/>

<TextField
  fullWidth
  label="Father's Phone Number"
  name="fatherPhoneNumber"
  value={formData.fatherPhoneNumber}
  onChange={handleInputChange}
  error={!!errors.fatherPhoneNumber}
  helperText={errors.fatherPhoneNumber}

  InputProps={{
                readOnly: true,
                sx: {
                  backgroundColor: "#e0e0e0",
                  color: "#666",
                  fontWeight:'bold',
                  borderRadius: "5px",
                  pointerEvents: "none", 
                  "& .MuiInputBase-input": { color: "#666", cursor: "default" },
                },
              }}
/>

<TextField
  fullWidth
  label="Address"
  name="address"
  value={formData.address || "N/A"}
  onChange={handleInputChange}
  error={!!errors.address}
  helperText={errors.address}

  InputProps={{
                readOnly: true,
                sx: {
                  backgroundColor: "#e0e0e0",
                  color: "#666",
                  fontWeight:'bold',
                  borderRadius: "5px",
                  pointerEvents: "none", 
                  "& .MuiInputBase-input": { color: "#666", cursor: "default" },
                },
              }}
             
/>

<TextField
  fullWidth
  label="Gender"
  name="gender"
  value={formData.gender}
  onChange={handleInputChange}
  error={!!errors.gender}
  helperText={errors.gender}

  InputProps={{
                readOnly: true,
                sx: {
                  backgroundColor: "#e0e0e0",
                  color: "#666",
                  fontWeight:'bold',
                  borderRadius: "5px",
                  pointerEvents: "none", 
                  "& .MuiInputBase-input": { color: "#666", cursor: "default" },
                },
              }}
/>

<TextField
  fullWidth
  label="Father EmailId"
  name="email"
  value={formData.email || "N/A"}
  onChange={handleInputChange}
  error={!!errors.email}
  helperText={errors.email}

  InputProps={{
                readOnly: true,
                sx: {
                  backgroundColor: "#e0e0e0",
                  color: "#666",
                  fontWeight:'bold',
                  borderRadius: "5px",
                  pointerEvents: "none", 
                  "& .MuiInputBase-input": { color: "#666", cursor: "default" },
                },
              }}
/>

         

          <FormControl fullWidth error={!!errors.busNumber}>
  <InputLabel id="bus-select-label">Bus Number</InputLabel>
  <Select
    labelId="bus-select-label"
    name="busNumber"
    value={formData.busNumber || ""}
    onChange={handleInputChange}
    label="Bus Number"
  >
    {busLoading ? (
      <MenuItem disabled>Loading...</MenuItem>
    ) : busNumbers.length > 0 ? (
      busNumbers.map((bus) => (
        <MenuItem key={bus.id} value={bus.busNumber}>
          {bus.busNumberPlate} {/* 👈 shows Plate */}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No Buses Available</MenuItem>
    )}
  </Select>
</FormControl>


           <FormControl
            fullWidth
            error={!!errors.routeNumber}
            sx={{ backgroundColor: "#f0f0f0", borderRadius: "5px" }}
          >
            <TextField
              name="routeNumber"
              value={formData.routeNumber || ""}
              label="Route No"
              InputProps={{
                readOnly: true,
                sx: {
                  backgroundColor: "#e0e0e0",
                  color: "#666",
                  fontWeight:'bold',
                  borderRadius: "5px",
                  pointerEvents: "none", 
                  "& .MuiInputBase-input": { color: "#666", cursor: "default" },
                },
              }}
            />
          </FormControl>



<FormControl fullWidth   error={!!errors.studentPickupLocation}>
  <InputLabel>Student Pickup Location</InputLabel>
  <Select
    name="studentPickupLocation"
    value={formData.studentPickupLocation}
    onChange={handleInputChange}
    label="Student Pickup Location"
  >
    {stops.map((stop, idx) => (
      <MenuItem key={idx} value={stop}>
        {stop}
      </MenuItem>
    ))}
  </Select>
</FormControl>

<TextField
            fullWidth
            label="Student Drop Location"
            name="studentDropLocation"
            value={formData.studentDropLocation}
            onChange={handleInputChange}
            error={!!errors.studentDropLocation}
            helperText={errors.studentDropLocation}
          />

<TextField
            fullWidth
            label="Distance"
            name="distance"
            value={formData.distance}
            onChange={handleInputChange}
            error={!!errors.distance}
            helperText={errors.distance}
          />

          <TextField
            fullWidth
            label="Bus TotalFee"
            name="busTotalFee"
            value={formData.busTotalFee}
            onChange={handleInputChange}
            error={!!errors.busTotalFee}
            helperText={errors.busTotalFee}
          />
         
                          {/* <FormControl fullWidth>
                            <InputLabel>Select Admin</InputLabel>
                            <Select
                              value={selectedadminUsers}
                              onChange={(e) => setSelectedadminUsers(e.target.value)}
                              name="admStaffUserId"
                              // onBlur={handleBlur}
                              label="Select Admin"
                              // error={!!touched.userRoleName && !!errors.userRoleName}
                            >
                              {adminusers.map((user) => (
                                <MenuItem key={user.userId} value={user.userId}>
                                  {user.userId}-{user.firstName} {user.lastName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl> */}
                       
        {/* Dropdown at Right End */}
  {/* {isPrincipal && (
    <Grid item xs={6} >
      <FormControl fullWidth size="small" sx={{ height: 50 }} >
        <InputLabel>Select Transport Admin</InputLabel>
        <Select
          value={selectedUsers}
          onChange={(e) => setSelectedUsers(e.target.value)}
          label="Select Transport Admin"
          sx={{ height: "50px", display: "flex", alignItems: "center" }} // Ensuring consistent height
        >
          {users.map((user) => (
            <MenuItem key={user.userId} value={user.userId}>
              {user.userId} - {user.firstName} {user.lastName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  )} */}



          
        </Box>

        {/* Register Button */}
        <Grid container justifyContent="right" sx={{ marginTop: 4 }}>
          <Grid item>
          <Button
  variant="contained"
  onClick={handleSubmit}
  style={{
    backgroundColor: "#3C3972",
    fontWeight: "bold",
    height: "40px",
    minWidth: "150px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }}
  disabled={loading} // Disable button when loading
>
  {loading ? <CircularProgress size={24} color="inherit" /> : "Register Student"}
</Button>

          </Grid>
        </Grid>
      </form>
      <ToastContainer position="top-right" />
    </Box>
  );
};